export const SENSITIVE_DATA_CLASS = 'fs-hide';
export default SENSITIVE_DATA_CLASS;
